<template>
  <div id="app">
    <trHeader v-if="this.$root._route.meta.tur" />
    <Ssheader v-else />
    <router-view></router-view>
    <trFooter v-if="this.$root._route.meta.tur" />
    <Ssfooter v-else />
  </div>
</template>

<script>
import Ssheader from "@/components/header.vue";
import trHeader from "@/views/header";
import Ssfooter from "@/components/footer.vue";
import trFooter from "@/views/footer";

export default {
  components: {
    Ssheader,
    Ssfooter,
    trHeader,
    trFooter
  },
  name: 'app',
  data() {
    return {
      msg: 'SarıkayaŞahin Web Development by Kaan KÜÇÜK',
    }
  },

}
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Rajdhani:600|Saira+Extra+Condensed");

@font-face {
	font-family: "SairaSemiCondensed-Regular";
	src: url("../static/font/SairaSemiCondensed-Regular.ttf") format("truetype");
	font-weight: normal;
	font-style: normal;
}

@font-face {
	font-family: "SEC";
	src: url("../static/font/SEC/SairaExtraCondensed-Regular.ttf")
		format("truetype");
	font-weight: normal;
	font-style: normal;
}

@font-face {
	font-family: "Agency";
	src: url("../static/font/Agency_FB.ttf") format("truetype");
	font-weight: normal;
	font-style: normal;
}

#app {
	height: 100vh;
}

html {
	font-size: 14px;
	font-family: "Agency", sans-serif;
}

h1 {
	font-size: 40px;
	font-weight: 900;
	color: #e4e4e4;
}

h1,
h2,
h3,
a {
	font-family: "Agency", sans-serif;
}

p,
li {
	font-size: 1.2rem;
	font-family: "SEC", sans-serif;
}

h2 {
	font-size: 2rem;
}

div.column.is-one-quarter::after {
	content: "";
	position: absolute;
	right: 12%;
	top: 0;
	height: 100%;
	background: #81a716;
	width: 1px;
}

div.column.is-one-quarter {
	position: relative;
}

div.tile.is-parent.is-3.is-vertical::after {
	content: "";
	position: absolute;
	right: 12%;
	top: 0;
	height: 100%;
	background: #81a716;
	width: 1px;
}

div.tile.is-parent.is-3.is-vertical {
	position: relative;
}

.hello {
	height: 100%;
}

.navk {
	justify-content: flex-end;
}

.navk a {
	font-family: "SEC", sans-serif;
	text-transform: uppercase;
	font-size: 17px;
}

.navk a:hover,
.navk .router-link-exact-active {
	border-bottom-color: #81a716;
	border-bottom-style: solid;
	border-bottom-width: 3px;
	color: #81a716;
	padding-bottom: calc(0.5rem - 3px);
}

.navbar {
	min-height: 5.55rem;
}

.navbar-item img {
	max-height: 8vh;
}

/* .navbar-item img {
  max-height: 4.25rem;
} */

.hello h1 {
	padding-bottom: 250px;
}

.Ssheader {
	background: whitesmoke;
}

@media only screen and (max-width: 768px) {
	.navbar {
		display: flex;
		align-items: center;
	}

	.navbar-item img {
		height: 25px;
		width: 154px;
	}

	.navMenu {
		display: flex;
		flex-direction: column;
		position: absolute;
		right: 0;
		left: 0;
		margin: auto;
		top: 60px;
		background: #efefef;
		z-index: 20;
	}
}

@media only screen and (max-width: 768px) {
	#app {
		overflow: scroll;
		overflow-x: hidden;
	}
}
</style>



// WEBPACK FOOTER //
// App.vue?77204818